import React, { useState } from "react";
const FileManagerContext = React.createContext();
import { SubscribeExternalModuleReactAPI } from "@coreapp/main";

const FileManagerProvider = ({ children }) => {
  let defaultContextValue = {
    showFileManager: false,
    selectButtonString: null,
    onSelectCommand: null,
    onCloseCommand: null,
    title: null,
    customOnSelect: null,
    selectDisabled: true,
    defaultInputFilename: null
  };
  const [fileManager, setFileManager] = useState({ state: null });
  const [contextValue, setContextValue] = useState(defaultContextValue);

  const GetContextValue = () => {
    return contextValue;
  };

  React.useEffect(() => {
    SubscribeExternalModuleReactAPI(
      {
        stateSetter: setFileManager,
        contextSetter: UpdateFileManagerContext,
        contextGetter: GetContextValue
      },
      "fileMgr"
    );
  }, []);

  const UpdateFileManagerContext = newValue => {
    setContextValue(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return (
    <FileManagerContext.Provider
      value={{
        fileManager,
        contextValue,
        setFileManager,
        setContextValue,
        UpdateFileManagerContext
      }}
    >
      {children}
    </FileManagerContext.Provider>
  );
};

export const useFileManagerContext = () => React.useContext(FileManagerContext);

export default FileManagerProvider;
